<div class="p-6" data-testid="cash-payment-max-amount-page">
  @if (canView()) {
    <p-toast />
    <div class="mb-6">
      <h2 class="text-2xl font-semibold text-gray-800">
        {{ 'cash_payment_max_amount.title' | translate }}
      </h2>
      <p class="text-sm text-gray-500 mt-1">
        {{ 'cash_payment_max_amount.subtitle' | translate }}
      </p>
    </div>

    <div
      class="flex flex-col gap-5 max-w-xl"
      [class.opacity-70]="loading()"
      [class.pointer-events-none]="loading()"
    >
      <div class="flex flex-col gap-2">
        <label for="maxAmount" class="text-sm font-medium text-gray-700">
          {{ 'cash_payment_max_amount.fields.max_amount' | translate }}
        </label>
        <p-inputNumber
          inputId="maxAmount"
          [ngModel]="maxAmount()"
          (ngModelChange)="maxAmount.set($event)"
          [min]="0"
          mode="currency"
          currency="VND"
          locale="vi-VN"
          [disabled]="!canEdit() || loading() || saving()"
        />
      </div>

      <div class="flex items-center justify-between">
        <label for="enabled" class="text-sm font-medium text-gray-700">
          {{ 'cash_payment_max_amount.fields.enabled' | translate }}
        </label>
        <p-toggleswitch
          inputId="enabled"
          [ngModel]="enabled()"
          (ngModelChange)="enabled.set($event)"
          [disabled]="!canEdit() || loading() || saving()"
        />
      </div>

      @if (canEdit()) {
        <div class="flex gap-3">
          <app-button
            [label]="'common.actions.save' | translate"
            type="info"
            [loading]="saving()"
            [disabled]="loading()"
            (emitOnClick)="save()"
          />
        </div>
      }
    </div>
  }
</div>
